export default "../../img/cover.jpeg";